module.exports = __webpack_public_path__ + "static/media/yrbTRON8 - 1.fadb345a.jpg";